
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-5'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 단체여행 문의 {{ $route.query.group_inquiry_ID === undefined ? '등록' : '상세확인' }}
          </p>
          <div class="Admin_PageHeader_btn">
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_write'>문의자명</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_write'
                readonly
                v-model="formData.groupInquiryWrite"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_phone_number'>휴대폰 번호</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_phone_number'
                readonly
                v-model="formData.groupInquiryPhoneNumber"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_email'>이메일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_email'
                readonly
                v-model="formData.groupInquiryEmail"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_expected_number'>예상인원</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_expected_number'
                readonly
                v-model="formData.groupInquiryExpectedNumber"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_start_date'>여행기간 시작일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_start_date'
                readonly
                v-model="formData.groupInquiryStartDate"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_end_date'>여행기간 종료일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_end_date'
                readonly
                v-model="formData.groupInquiryEndDate"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_expected_expenses'>예상경비</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_expected_expenses'
                readonly
                v-model="formData.groupInquiryExpectedExpenses"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_desired_area'>희망지역</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'group_inquiry_desired_area'
                readonly
                v-model="formData.groupInquiryDesiredArea"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='group_inquiry_word_advice'>남기실말씀</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="group_inquiry_word_advice"
                readonly
                rows="5"
                v-model="formData.groupInquiryWordAdvice"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_group_inquiry_one
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminGroupInquiryManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  setup () {
    return {
      formData: ref({
        groupInquiryWrite: '',
        groupInquiryPhoneNumber: '',
        groupInquiryEmail: '',
        groupInquiryExpectedNumber: '',
        groupInquiryStartDate: '',
        groupInquiryEndDate: '',
        groupInquiryExpectedExpenses: '',
        groupInquiryDesiredArea: '',
        groupInquiryWordAdvice: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  mounted () {
    if (this.$route.query.group_inquiry_ID !== undefined) {
      get_group_inquiry_one(this.$route.query.group_inquiry_ID).then((result) => {
        this.formData.groupInquiryWrite = result[0].group_inquiry_write
        this.formData.groupInquiryPhoneNumber = result[0].group_inquiry_phone_number
        this.formData.groupInquiryEmail = result[0].group_inquiry_email
        this.formData.groupInquiryExpectedNumber = result[0].group_inquiry_expected_number.toLocaleString() + '명'
        this.formData.groupInquiryStartDate = result[0].group_inquiry_start_date
        this.formData.groupInquiryEndDate = result[0].group_inquiry_end_date
        this.formData.groupInquiryExpectedExpenses = result[0].group_inquiry_expected_expenses.toLocaleString() + '만원'
        this.formData.groupInquiryDesiredArea = result[0].group_inquiry_desired_area
        this.formData.groupInquiryWordAdvice = result[0].group_inquiry_word_advice
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminGroupInquiryManagementAdd.vue